var _style, _path, _defs, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsFile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E8ECEF;}\n\t.st1{clip-path:url(#SVGID_00000067235800372899806980000016938304560127720115_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#79AC00;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#B4E441;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,0.5h262c6.9,0,12.5,5.6,12.5,12.5v262c0,6.9-5.6,12.5-12.5,12.5H13c-6.9,0-12.5-5.6-12.5-12.5V13 C0.5,6.1,6.1,0.5,13,0.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 110.3,
    y: 100,
    width: 67.4,
    height: 88
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124864168350110033470000005331989141016372373_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124864168350110033470000005331989141016372373_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.7,123.2v57.9c0,3.8-3.1,6.9-7,6.9h-53.4c-3.8,0-7-3.1-7-6.9v-74.1c0-3.8,3.1-6.9,7-6.9h37.2 L177.7,123.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.8,151.8c-0.7,0-1.2,0.1-1.5,0.3c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.2,0.6,0.5,0.8 c0.3,0.2,0.9,0.4,1.8,0.6c1.5,0.4,2.6,0.7,3.2,1.1c0.6,0.4,1.1,0.8,1.4,1.3c0.3,0.5,0.5,1.2,0.5,2c0,0.9-0.2,1.6-0.7,2.2 c-0.4,0.6-1.1,1.1-1.9,1.4c-0.8,0.3-1.7,0.5-2.8,0.5c-2.7,0-4.6-0.8-5.6-2.3l2.4-1.7c0.4,0.5,0.8,0.9,1.4,1.1 c0.5,0.2,1.1,0.3,1.6,0.3c1.5,0,2.3-0.4,2.3-1.3c0-0.4-0.2-0.7-0.6-0.9c-0.4-0.2-1.1-0.4-2-0.7c-1.7-0.4-3-0.9-3.7-1.6 c-0.7-0.7-1.1-1.6-1.1-2.7c0-1.2,0.4-2.1,1.3-2.8c0.9-0.7,2.2-1.1,3.9-1.1c1.2,0,2.2,0.2,3.1,0.6c0.9,0.4,1.6,0.9,2.1,1.7 l-2.4,1.7C156,152.3,155.1,151.8,153.8,151.8z M142.3,144.1h3.2v18.5h-3.2V144.1z M136.3,162.6l-2.6-4.2l-2.7,4.2h-3.6l4.5-6.4 l-4.4-6.6h3.8l2.6,4.1l2.7-4.1h3.6l-4.5,6.4l4.5,6.6H136.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.7,121.9v2.9h-19c-3.9,0-5.7-3.2-5.7-7.1V100h2.9L177.7,121.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFile01);
export default __webpack_public_path__ + "static/media/xls-file-01.fc94a0d3221d2b3fcbd454aa46bb18e1.svg";
export { ForwardRef as ReactComponent };